"use client";

import FusePageSimple from "@fuse/core/FusePageSimple";

export function IndexView() {
	return <FusePageSimple />;
}
